export default __webpack_public_path__ + "static/media/GreyProfile.7e162b20.svg";